import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-edit-anz-popup',
  templateUrl: './edit-anz-popup.component.html',
  styleUrls: ['./edit-anz-popup.component.scss'],
})
export class EditAnzPopupComponent implements OnChanges, OnInit {
  @Input() minAnz: number;
  @Input() maxAnz: number;
  @Input() amount: number;
  isEinfachauswahl: boolean = false;
  isPflichtfeld: boolean = false;

  constructor(private modalCtrl: ModalController) { }

  ngOnInit() {
    this.updateCheckboxes();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.minAnz || changes.maxAnz || changes.amount) {
      this.updateCheckboxes();
    }
  }

  dismiss(data?: any) {
    this.modalCtrl.dismiss(data);
  }

  save() {
    if (this.minAnz > this.maxAnz) {
      this.minAnz = this.maxAnz;
    }
    // Validiere die Menge vor dem Speichern
    this.validateAmount();
    this.dismiss({ minAnz: this.minAnz, maxAnz: this.maxAnz, amount: this.amount });
  }

  onEinfachauswahlChange() {
    if (this.isEinfachauswahl) {
      if (this.isPflichtfeld) {
        this.minAnz = 1;
      } else {
        this.minAnz = 0;
      }
      this.maxAnz = 1;
      // Bei Einfachauswahl darf die Menge maximal 1 sein
      if (this.amount > 1) {
        this.amount = 1;
      }
    }
    this.validateAmount();
  }

  onPflichtfeldChange() {
    if (this.isPflichtfeld) {
      this.minAnz = 1;
    }
    this.validateAmount();
  }

  private updateCheckboxes() {
    if (this.minAnz > this.maxAnz) {
      this.maxAnz = this.minAnz;
    }
    this.isEinfachauswahl = (this.minAnz === 0 || this.minAnz === 1) && this.maxAnz === 1;
    this.isPflichtfeld = this.minAnz > 0;
    this.validateAmount();
  }

  private validateAmount() {
    if (this.amount != null) {
      // Stelle sicher, dass die Menge nicht unter der minimalen Anzahl liegt
      if (this.minAnz != null && this.amount < this.minAnz) {
        this.amount = this.minAnz;
      }
      
      // Stelle sicher, dass die Menge nicht über der maximalen Anzahl liegt
      if (this.maxAnz != null && this.amount > this.maxAnz) {
        this.amount = this.maxAnz;
      }

      // Bei Einfachauswahl darf die Menge maximal 1 sein
      if (this.isEinfachauswahl && this.amount > 1) {
        this.amount = 1;
      }

      // Stelle sicher, dass die Menge nicht negativ ist
      if (this.amount < 0) {
        this.amount = 0;
      }
    }
  }

  onAmountChange() {
    this.validateAmount();
  }
}